export default {
  authChanged: "auth:changed",
  lastVerifiedCommands: "lastVerifiedCommands",
};
